import React from 'react';
import './SearchBar.css';
import binocularsIcon from "../../assets/binoculars.png";

const SearchBar = ({ value, handleSearchKey, clearSearch, formSubmit, isSearchActive, submittedQuery, resultCount }) => {
  return (
    <div className="wrapper">
      <form className="searchBar" onSubmit={formSubmit}>
        <div className="inputWrap">
          <input
            id="searchQueryInput"
            type="text"
            name="searchQueryInput"
            placeholder="Find Your Adventure..."
            value={value}
            onChange={handleSearchKey}
          />
          {value && (
            <button
              type="button"
              className="clearButton"
              onClick={clearSearch}
              aria-label="Clear search"
            >
              ×
            </button>
          )}
        </div>
        <button id="searchQuerySubmit" type="submit" name="searchQuerySubmit">
          <img
            src={binocularsIcon}
            alt="Search"
            style={{ width: '24px', height: '24px' }}
          />
        </button>
      </form>
      {isSearchActive && (
        <p className="resultCount">
          {resultCount} result{resultCount !== 1 ? 's' : ''} for "{submittedQuery}"
        </p>
      )}
    </div>
  );
};

export default SearchBar;
